"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VectorInput = void 0;
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const theme_1 = require("../theme");
const bearing_input_1 = require("./bearing.input");
const distance_input_1 = require("./distance.input");
const vector_input_style_1 = require("./vector.input.style");
(0, theme_1.addStyles)(vector_input_style_1.Style);
exports.VectorInput = {
    view(state) {
        return (0, mithril_1.m)('div', { className: vector_input_style_1.CSS.container }, [
            (0, mithril_1.m)('div', { className: vector_input_style_1.CSS.inputs }, [
                (0, mithril_1.m)('div', { className: vector_input_style_1.CSS.leftInput }, distance_input_1.DistanceInput.view(state.distance)),
                (0, mithril_1.m)('div', { className: vector_input_style_1.CSS.rightInput }, bearing_input_1.BearingInput.view(state.bearing)),
            ]),
            state.hasError() ? (0, mithril_1.m)('span', { className: vector_input_style_1.CSS.MDL.error + ' ' + vector_input_style_1.CSS.error }, (0, i18n_1.Translate)(state.error)) : null,
        ]);
    },
};
//# sourceMappingURL=vector.input.js.map